// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__eqs8_","head":"ProcedureTableInfo_head__34e6Y"};